<template>
  <div
    :id="fieldId"
    class="sfmc"
    :data-default-content="showFallback.toString()"
    v-bind="additionalProperties"
  >
    <slot
      v-if="showRecommendationList"
      name="recommendations"
      :recommendations="recommendations"
      :component-data="componentData"
    />
    <slot
      v-if="showFallback"
      name="default-list"
    />
  </div>
</template>

<script>
  /* eslint-disable no-undef */
  import { intersectionViewportObserver } from '@Foundation/utilities/intersectionViewportObserver';

  export default {
    name: 'SfmcContainer',
    props: {
      apiUrl: {
        type: String,
        required: true,
        default: '/api/sfmc/sfmc-articles'
      },
      payloadConfig: {
        type: Object,
        required: true
      },
      enabled: {
        type: Boolean,
        required: true
      },
      fieldId: {
        type: String,
        default: () => {
          const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
            /[xy]/g,
            function(c) {
              const r = (Math.random() * 16) | 0,
                    v = c === 'x' ? r : (r & 0x3) | 0x8;
              return v.toString(16);
            }
          );

          return `sfmc-container-${uuid}`;
        }
      }
    },
    data() {
      return {
        success: false,
        loading: this.enabled,
        recommendations: [],
        experienceId: null,
        userGroup: null,
        pollingId: undefined,
        componentData: null
      };
    },
    computed: {
      showRecommendationList() {
        return this.loading ? false : this.success;
      },
      showFallback() {
        return this.loading ? false : !this.enabled || !this.success;
      },
      additionalProperties() {
        if (!this.experienceId || !this.userGroup) {
          return {};
        }

        return {
          ...this.$attrs,
          'data-evg-experience-id': this.experienceId,
          'data-evg-user-group': this.userGroup,
          'data-evg-campaign-id': this.payloadConfig.campaign
        };
      }
    },
    mounted() {
      if (this.enabled) {
        intersectionViewportObserver(this.$el, { checkIsVisible: false }).then(
          () => {
            this.getRecommendedItems();
          }
        );
      } else {
        this.loading = false;
      }
    },
    methods: {
      async getRecommendedItems() {
        if (this.enabled) {
          this.payloadConfig.currentItemType = window.interactionStudioData
            ? window.interactionStudioData.itemType
            : '';
          this.payloadConfig.currentISItemId = window.interactionStudioData
            ? window.interactionStudioData.itemId
            : '';

          fetch(this.apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=utf-8' },
            credentials: 'same-origin',
            body: JSON.stringify(this.payloadConfig)
          })
            .then(response => response.json())
            .then(res => {
              if (res.success) {
                this.recommendations = res.recommendations;
                this.success =
                  res.recommendations && res.recommendations.length > 0;
                this.experienceId = res.experienceId;
                this.userGroup = res.userGroup;
                this.componentData = res.componentData;

                this.$nextTick(() => {
                  this.polling();
                });
              } else {
                this.success = false;
              }
            })
            .catch(error => {
              console.error('Could not load recommended items', error); // eslint-disable-line no-console
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      },
      userHasInteracted() {
        this.getRecommendedItems();
      },
      polling() {
        if (window.Evergage) {
          this.pollingId = setInterval(() => {
            if (window.Evergage.getCurrentPage().action) {
              this.emitISEvents();
              clearInterval(this.pollingId);
            }
          }, 400);
        }
      },
      emitISEvents() {
        if (this.success && window.Evergage) {
          window.Evergage.cashDom(`#${this.fieldId}`).attr({
            'data-evg-campaign-id': this.payloadConfig.campaign,
            'data-evg-experience-id': this.experienceId,
            'data-evg-user-group': this.userGroup
          });

          document.dispatchEvent(
            new CustomEvent(window.Evergage.CustomEvents.OnTemplateDisplayEnd, {
              detail: {
                payload: {
                  campaign: this.payloadConfig.campaign,
                  experience: this.experienceId,
                  userGroup: this.userGroup
                }
              }
            })
          );
        }
      }
    }
  };
</script>
